/**
 * author: Alex Lai
 * Support Website: https://laialex.com
 * Email: alex@laialex.com
 * Create Time: 2025/6/14
 */
import React, { Component } from 'react'
import * as ui from 'antd'
import apis from '../../../../utils/apis'
import { BellOutlined } from '@ant-design/icons'
import { PageHeader } from '@ant-design/pro-layout'
import { LoadingEnded, LoadingStart } from '../../../../utils/loading'
import FormatUtils from '../../../../utils/FormatUtils'


const { TextArea } = ui.Input
const { Option } = ui.Select

export default class CrawlerTarget extends Component {
  constructor() {
    super()
    this.state = {
      tableData: [],
      paging: { total: 0, pageNumber: 1, pageSize: 20 },
      tableLoad: false,
      searchKey: {},
      editShow: false,
      editCurr: {},
      submitting: false,
      engine: [],
      searchAsync: null,
      gatherType: []
    }
  }

  componentDidMount() {
    this.gatherTypeSync()
    this.executeEnginesSync()
    this.tableDataSync(1)
  }

  /**
   * 采集类型加载
   */
  gatherTypeSync() {
    var that = this
    apis.crawlerTypeList({}).then(res => {
      that.setState({
        gatherType: res.data.data
      })
    })
  }

  /**
   * 加载执行分组
   */
  executeEnginesSync(filter = {}) {
    var param = {}
    param.pageNumber = 1
    param.pageSize = 20
    Object.assign(param, filter)
    var that = this
    LoadingStart()
    apis.crawlerSourceList(param).then(res => {
      LoadingEnded()
      that.setState({
        engine: res.data.data.data
      })
    })
  }

  /**
   * 发起搜索
   * @param params
   * @constructor
   */
  makeSearch = (params) => {
    this.setState({
      searchKey: params
    })
    var that = this
    setTimeout(function() {
      that.tableDataSync()
    }, 200)
  }
  /**
   * 签名列表
   * @param pageNumber
   Object.assign(para, that.state.keywords)
   * @param pageSize
   * @constructor
   */
  tableDataSync = (pageNumber = 1) => {
    let that = this
    let para = {}
    para.pageNumber = pageNumber
    para.pageSize = 20
    that.setState({
      tableLoad: true
    })
    Object.assign(para, that.state.searchKey)
    apis.crawlerTargetList(para).then(function(resp) {
      that.setState({
        tableLoad: false
      })
      var curr = {
        total: resp.data.data.total,
        pageNumber: pageNumber
      }
      that.setState({
        tableData: resp.data.data.data,
        paging: curr
      })
    })
  }


  render() {
    var that = this

    const columns = [
      {
        title: 'ID',
        dataIndex: 'id'
      },
      {
        title: '采集源',
        key: 'id',
        render: function(value, row, index) {
          return (
            <div>{row.engine.name}</div>
          )
        }
      },
      {
        title: '采集数据类型',
        key: 'id',
        render: function(value, row, index) {
          return (
            <div>{row.gather_type.name}</div>
          )
        }
      },
      {
        title: '采集目标名称',
        key: 'id',
        render: function(value, row, index) {
          return (
            <div style={{ fontSize: '22px' }}>{row.name}</div>
          )
        }
      },
      {
        title: '响应数据类型',
        key: 'id',
        render: function(value, row, index) {
          return (
            <div>{row.content_type}</div>
          )
        }
      },
      {
        title: '可用',
        key: 'id',
        render: function(value, row, index) {
          return (
            <ui.Button shape={'round'} type={'circle'}>{row.state ? '是' : '否'}</ui.Button>
          )
        }
      },
      {
        title: '管理',
        key: 'id',
        fixed: 'right',
        render: function(value, row, index) {
          return (
            <span>
                 <ui.Button onClick={() => {
                   var data = JSON.parse(JSON.stringify(row))
                   data.engine = data.engine.id
                   data.gather_type = data.gather_type.id
                   that.setState({
                     editCurr: data,
                     editShow: true
                   })
                 }} type={'link'}>编辑</ui.Button>
            </span>
          )
        }
      }
    ]

    return (
      <div>
        <PageHeader title="采集目标管理" subTitle="针对源的不同采集目标进行管理" extra={[
          <ui.Button key="1" type="primary" shape="round" onClick={() => {
            that.setState({
              editCurr: {},
              editShow: true,
              submitting: false
            })
          }}>新增采集目标</ui.Button>
        ]} />
        <ui.Card>
          <div style={{ marginTop: '22px' }}>
            <ui.Form onFinish={that.makeSearch} layout={'inline'}>
              <ui.Form.Item label={'目标名称'} name={'name__contains'}>
                <ui.Input placeholder={'目标名称'} />
              </ui.Form.Item>
              <ui.Form.Item label={'采集源'} name={'engine__name__contains'}>
                <ui.Input placeholder={'采集源'} />
              </ui.Form.Item>
              <ui.Form.Item>
                <ui.Button type={'primary'} htmlType={'submit'}>快速搜索</ui.Button>
              </ui.Form.Item>
            </ui.Form>
          </div>
        </ui.Card>

        <div style={{ marginTop: '22px' }}>
          <ui.Table
            rowKey="id"
            dataSource={this.state.tableData}
            columns={columns}
            loading={this.state.tableLoad}
            pagination={{
              total: this.state.paging.total,
              defaultPageSize: 20,
              defaultCurrent: this.state.paging.pageNumber,
              onChange: this.tableDataSync
            }} />
        </div>

        <ui.Modal width={"80vw"} open={that.state.editShow} title={'采集目标管理'} onCancel={() => {
          that.setState({
            editCurr: {},
            editShow: false,
            submitting: false
          })
        }} footer={null} destroyOnClose>
          <ui.Form onFinish={(params => {
            that.setState({
              submitting: true
            })
            if (that.state.editCurr.id) {
              params.id = that.state.editCurr.id
            }
            params = FormatUtils.FormDataJsonDecoder(params)
            apis.crawlerTargetModify(params).then(resp => {
              that.setState({
                submitting: false
              })
              if (resp.data.code === 200) {
                ui.message.success('提交信息成功')
                that.tableDataSync(that.state.editCurr.id ? that.state.paging.pageNumber : 1)
                that.setState({
                  submitting: false,
                  editShow: false,
                  editCurr: {}
                })
              } else {
                ui.message.error(resp.data.data.msg ? resp.data.data.msg : resp.data.msg)
              }
            })
          })} labelCol={{ span: 24 }} labelAlign={'left'} initialValues={that.state.editCurr}>
            <ui.Row gutter={16}>
              <ui.Col span={14}>
                <ui.Card styles={{
                  body: {
                    backgroundColor: '#fdedcc'
                  }
                }}>
                  <ui.Form.Item label={'采集目标'} name={'name'}
                                rules={[{ required: true, message: '采集目标' }]}>
                    <ui.Input placeholder={'执行客户端名称'} />
                  </ui.Form.Item>
                  <ui.Form.Item label={'简介'} name={'brief'}
                                rules={[{ required: true, message: '简介' }]}>
                    <TextArea rows={5} placeholder={'请确认您需要绑定的采集源'} />
                  </ui.Form.Item>
                  <ui.Form.Item label={'采集类型'} name={'gather_type'}
                                rules={[{ required: true, message: '采集类型' }]}>
                    <ui.Select placeholder={'选择使用的采集类型'} style={{ width: '100%' }}>
                      {that.state.gatherType.map(item => {
                        return (
                          <Option value={item.id} key={item.id}>{item.name}</Option>
                        )
                      })}
                    </ui.Select>
                  </ui.Form.Item>
                  <ui.Form.Item label={'采集目标可用'} name={'state'}
                                rules={[{ required: true, message: '采集目标可用' }]}>
                    <ui.Radio.Group>
                      <ui.Radio value={true}>可用</ui.Radio>
                      <ui.Radio value={false}>禁用</ui.Radio>
                    </ui.Radio.Group>
                  </ui.Form.Item>
                  <ui.Form.Item label={'相对地址'} name={'relative_url'}
                                rules={[{ required: true, message: '相对地址' }]}>
                    <ui.Radio.Group onChange={e => {
                      that.setState({
                        editCurr: {
                          ...that.state.editCurr,
                          relative_url: e.target.value
                        }
                      })
                    }}>
                      <ui.Radio value={true}>是</ui.Radio>
                      <ui.Radio value={false}>否</ui.Radio>
                    </ui.Radio.Group>
                  </ui.Form.Item>
                  <ui.Form.Item label={'采集源'} name={'engine'} rules={[{ required: true, message: '采集源' }]}>
                    <ui.Select showSearch placeholder={'请确认您需要绑定的采集源'} style={{ width: '100%' }}
                               onSearch={(e) => {
                                 if (e) {
                                   clearTimeout(that.state.searchAsync)
                                   that.setState({
                                     searchAsync: setTimeout(() => {
                                       that.executeEnginesSync({
                                         name__contains: e
                                       })
                                     }, 1000)
                                   })
                                 }
                               }}>
                      {that.state.engine.map(item => {
                        return (
                          <Option value={item.id} key={item.id}>{item.name}</Option>
                        )
                      })}
                    </ui.Select>
                  </ui.Form.Item>

                  <ui.Form.Item label={'访问器'} name={'visit'}
                                rules={[{ required: true, message: '访问器' }]}>
                    <ui.Radio.Group>
                      <ui.Radio value={'http'}>http请求</ui.Radio>
                      <ui.Radio value={'browser'}>浏览器访问</ui.Radio>
                    </ui.Radio.Group>
                  </ui.Form.Item>
                  <ui.Form.Item label={'采集目标类型'} name={'target_type'}
                                rules={[{ required: true, message: '采集目标类型' }]}>
                    <ui.Radio.Group onChange={e => {
                      that.setState({
                        editCurr: {
                          ...that.state.editCurr,
                          target_type: e.target.value
                        }
                      })
                    }}>
                      <ui.Radio value={'single'}>单页采集</ui.Radio>
                      <ui.Radio value={'page'}>分页采集</ui.Radio>
                    </ui.Radio.Group>
                  </ui.Form.Item>
                  <ui.Form.Item label={'内容类型'} name={'content_type'}
                                rules={[{ required: true, message: '内容类型' }]}>
                    <ui.Radio.Group>
                      <ui.Radio value={'html'}>HTML</ui.Radio>
                      <ui.Radio value={'json'}>JSON</ui.Radio>
                      <ui.Radio value={'xml'}>XML</ui.Radio>
                    </ui.Radio.Group>
                  </ui.Form.Item>
                  {that.state.editCurr.target_type}
                  {that.state.editCurr.target_type === 'page' &&
                    <ui.Card size={'small'} title={'分页采集参数'}>
                      <ui.Form.Item label={'起始页'} name={'meta__multiple_start_page_number'}
                                    rules={[{ required: true, message: '起始页' }]}>
                        <ui.InputNumber min={1} max={1800} style={{ width: '100%' }} placeholder={'起始页'} />
                      </ui.Form.Item>
                      <ui.Form.Item label={'自定义参数'} name={'meta__multiple_custom_attribute'}
                                    help={'json格式'}
                                    rules={[{ required: false, message: '自定义参数' }]}>
                        <TextArea rows={10} placeholder={'自定义参数'} />
                      </ui.Form.Item>
                      <ui.Form.Item label={'url模板'} name={'meta__multiple_url_format'}
                                    help={'可变URL： {currentUrl},页面码:{pageNumber},分页大小:{pageSize},所有采集对像采集以及自定义参数，自定义参数绑定在meta内，也可使用运行前为函数生成参数'}
                                    rules={[{ required: true, message: 'url模板' }]}>
                        <TextArea rows={5} placeholder={'url模板'} />
                      </ui.Form.Item>
                    </ui.Card>
                  }
                  <ui.Form.Item label={'页面入口地址'} name={'gate_url'}
                                rules={[{ required: true, message: '页面入口地址' }]}>
                    <ui.Input placeholder={'页面入口地址'} />
                  </ui.Form.Item>
                  {that.state.editCurr.relative_url &&
                    <ui.Form.Item label={'基础URL'} name={'base_url'}
                                  help="地址样式:https://www.baidu.com,在相对地址时使用"
                                  rules={[{ required: true, message: '基础URL' }]}>
                      <ui.Input placeholder={'基础URL'} />
                    </ui.Form.Item>
                  }
                </ui.Card>
              </ui.Col>
              <ui.Col span={10}>
                <ui.Form.Item label={'运行前'} name={'initial_exec'}
                              rules={[{ required: false, message: '运行前' }]}>
                  <TextArea rows={5} placeholder={'运行前'} />
                </ui.Form.Item>
                <ui.Form.Item label={'采集前'} name={'before_spider'}
                              rules={[{ required: false, message: '采集前' }]}>
                  <TextArea rows={5} placeholder={'采集前'} />
                </ui.Form.Item>
                <ui.Form.Item label={'采集后'} name={'after_spider'}
                              rules={[{ required: false, message: '采集后' }]}>
                  <TextArea rows={5} placeholder={'采集后'} />
                </ui.Form.Item>
                <ui.Form.Item label={'响应前'} name={'before_response'}
                              rules={[{ required: false, message: '响应前' }]}>
                  <TextArea rows={5} placeholder={'响应前'} />
                </ui.Form.Item>
              </ui.Col>
            </ui.Row>
            <ui.Form.Item>
              <ui.Button htmlType={'submit'} style={{marginTop:"26px"}} loading={that.state.submitting} type={'primary'} block>立即提交</ui.Button>
            </ui.Form.Item>
          </ui.Form>
        </ui.Modal>
      </div>
    )
  }
}